import { Component, Input, Output, EventEmitter, computed, signal, WritableSignal } from '@angular/core';
import { DrawerObject } from './drawer.types';
import { DrawerModule } from 'primeng/drawer';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'sm-drawer',
  standalone: true,
  imports: [DrawerModule, ButtonModule, CommonModule, TranslateModule],
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'], // ✅ plural
})
export class DrawerComponent {
  /** Signal to store drawer state reactively */
  private drawerSignal: WritableSignal<DrawerObject> = signal({} as DrawerObject);

  /** Drawer input */
  @Input()
  set drawer(value: DrawerObject | undefined) {
    this.drawerSignal.set(value || ({} as DrawerObject));
  }
  get drawer() {
    return this.drawerSignal();
  }

  /** Drawer visibility */
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  /** Computed signals for easy template usage */
  title = computed(() => this.drawerSignal()?.title || '');
  description = computed(() => this.drawerSignal()?.description || '');
  position = computed(() => this.drawerSignal()?.position || 'right');
  width = computed(() => this.drawerSignal()?.width || '25vw');
  closeOnEscape = computed(() => !!this.drawerSignal()?.closeOnEscape);
  dismissible = computed(() => !!this.drawerSignal()?.dismissable);

  /** Classes for container/header/body/footer */
  classes = computed(() => ({
    container: this.drawerSignal()?.classes?.container || '',
    header: this.drawerSignal()?.classes?.header || '',
    body: this.drawerSignal()?.classes?.body || '',
    footer: this.drawerSignal()?.classes?.footer || '',
  }));

  /** Toggle visibility */
  toggleVisible() {
    this.visible = !this.visible;
    this.visibleChange.emit(this.visible);
  }

  /** Emit onHide callback */
  onHide() {
    const onHideFn = this.drawerSignal()?.onHide;
    if (onHideFn) onHideFn();
  }
}
